import { render, staticRenderFns } from "./ClientLinksTile.vue?vue&type=template&id=816fa188&"
import script from "./ClientLinksTile.vue?vue&type=script&lang=js&"
export * from "./ClientLinksTile.vue?vue&type=script&lang=js&"
import style0 from "./ClientLinksTile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ClientLinksTile.vue"
export default component.exports